import Developers from '@/views/pages/pub/developers/Developers.vue';
import Atick from '@/views/pages/pub/developers/Atick.vue';
import SunGirl from '@/views/pages/pub/developers/SunGirl.vue';

export default [
  {
    path: '/developers',
    name: 'developers',
    component: Developers,
    meta: {
      title: 'Розробники проекту'
    },
    children: [
      {
        path: 'atick',
        name: 'developers.atick',
        component: Atick,
        meta: {
          title: 'Atick (Другак Іван)'
        }
      },
      {
        path: 'sun_girl',
        name: 'developers.sun_girl',
        component: SunGirl,
        meta: {
          title: 'SunGirl (Другак Тетяна)'
        }
      }
    ]
  }
];
